import { InvestTypes, InvestState } from '../types/invest'

const initialState: InvestState = {
  all: [],
  user: [],
  investmentPath: [],
  loading: false,
}

export const investReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case InvestTypes.GET_ALL_INVESTMENTS_LOADING:
      return {
        ...state,
        loading: true,
      }

    case InvestTypes.GET_ALL_INVESTMENTS_SUCCESS:
      return {
        ...state,
        all: action.payload,
        loading: false,
      }

    case InvestTypes.UPDATE_PAYMENT_PATH_FORM:
      return {
        ...state,
        investmentPath: {
          ...state.investmentPath,
          ...action.payload,
        },
      }

    case InvestTypes.GET_USER_INVESTMENTS_LOADING:
      return {
        ...state,
        loading: true,
      }

    case InvestTypes.GET_USER_INVESTMENTS_SUCCESS:
      return {
        ...state,
        user: action.payload,
        loading: false,
      }

    default:
      return state
  }
}
